export enum TThumbnailPositionEnum {
  View3D = "v",
  Left = "l",
  Right = "r",
  Front = "f",
  Back = "b",
  Top = "t",
  Bottom = "m",
}
